import * as Yup from "yup";
import { PerfilSituacao } from "./model";

export class PerfilSchema {
  public static id() {
    return Yup
      .number()
      .positive("Id deve ser um maior que zero");
  }

  public static record() {
    return Yup
      .object()
      .shape(recordShape);
  }

  public static createForm() {
    const {
      nome,
      situacao,
      menus,
    } = recordShape;

    const createFormShape = {
      nome,
      situacao,
      menus,
    };

    return Yup
      .object()
      .shape(createFormShape);
  }

  public static updateForm() {
    const {
      nome,
      situacao,
      menus,
    } = recordShape;

    const updateFormShape = {
      nome,
      situacao,
      menus,
    };

    return Yup
      .object()
      .shape(updateFormShape);
  }
}

const recordShape = {
  nome: Yup
    .string()
    .min(2, "Nome deve conter no mínimo 2 caracteres")
    .max(32, "Nome deve conter no máximo 32 caracteres")
    .required("Nome é obrigatório"),
  situacao: Yup
    .string()
    .oneOf(Object.values(PerfilSituacao))
    .required("Situação é obrigatório"),
  menus: Yup
    .array()
    .of(Yup.number()
      .required("Menus deve ser um array de números")),
};
